import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { show, hide } from "redux-modal";
import PropTypes from "prop-types";
import * as InventaryService from "../../../../services/InventaryService";
import { useTranslation } from "react-i18next";
import InventaryForm from "./inventaryForm.view";
import showDialog from "../../../utils/ShowDialog/ShowDialog";
import moment from "moment-timezone";
// import { ShowAlertDialog } from "@de-prado-dev/react-component-library";

const InventaryFormContainer = ({ data, onSuccess, isDcoop }) => {
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const [initValues, setInitValues] = useState({});

  const setInitialValues = useCallback(async (data) => {
    setInitValues(data);
  }, []);

  const loadData = useCallback(async () => {}, [setInitialValues, data]);

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        let result = await InventaryService.newInventary(values);

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          title = t("forms.inventary.messages.update.title");
          text = t("forms.inventary.messages.update.success");
          icon = "success";
        } else {
          title = "Error";
          text = t("forms.inventary.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          onSuccess();
        };
        showDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      console.log("Error", error);
      showDialog(
        "Error",
        error?.message || t("forms.inventary.messages.update.error"),
        "error",
        false,
        "OK",
        false
      );
    }
  };

  const handleOnback = (popupName) => {
    dispatch(hide(popupName));
  };

  return (
    <>
      <InventaryForm
        initialValues={initValues}
        onSubmit={handleSubmit}
        onback={handleOnback}
      />
    </>
  );
};

InventaryFormContainer.propTypes = {
  t: PropTypes.any,
};

export default InventaryFormContainer;
